export const theme = {
  colors: {
    primary: "#0077b6",
    secondary: "#00b4d8",
    accent: "#90e0ef",
    dark: "#03045e",
    light: "#caf0f8",
    white: "#ffffff",
    black: "#000000",
    gray: "#6c757d",
  },
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    laptop: "1024px",
    desktop: "1200px",
  },
  fonts: {
    primary: "'Poppins', sans-serif",
    secondary: "'Roboto', sans-serif",
  },
};
